import api from '@/lib/api';
import type { PaginatedResponse } from '@pms/shared';
import type { LostFoundItem } from './frontdeskOps.types';
import { LostFoundStatus } from './frontdeskOps.types';

export interface ListLostFoundQuery {
  propertyId: string;
  status?: LostFoundStatus | undefined;
  from?: string | undefined;
  to?: string | undefined;
  search?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export interface CreateLostFoundPayload {
  propertyId: string;
  description: string;
  foundDate: string;
  location: string;
  guestName?: string | undefined;
  guestMobile?: string | undefined;
  status?: LostFoundStatus | undefined;
  bookingId?: string | undefined;
  notes?: string | undefined;
}

export interface UpdateLostFoundPayload {
  status?: LostFoundStatus | undefined;
  location?: string | undefined;
  guestName?: string | undefined;
  guestMobile?: string | undefined;
  notes?: string | undefined;
  bookingId?: string | undefined;
}

export async function fetchLostFound(
  query: ListLostFoundQuery,
): Promise<PaginatedResponse<LostFoundItem>> {
  const { data } = await api.get<PaginatedResponse<LostFoundItem>>('/lost-found', {
    params: query,
  });
  return data;
}

export async function createLostFound(
  payload: CreateLostFoundPayload,
): Promise<LostFoundItem> {
  const { data } = await api.post<LostFoundItem>('/lost-found', payload);
  return data;
}

export async function fetchLostFoundItem(id: string): Promise<LostFoundItem> {
  const { data } = await api.get<LostFoundItem>(`/lost-found/${id}`);
  return data;
}

export async function updateLostFound(
  id: string,
  payload: UpdateLostFoundPayload,
): Promise<LostFoundItem> {
  const { data } = await api.patch<LostFoundItem>(`/lost-found/${id}`, payload);
  return data;
}
